import { Icon } from '@chakra-ui/react';

const CustomRealtimeUpdateIcon = (props) => (
  <Icon viewBox="0 0 27 35" fill="none" {...props}>
    <g clipPath="url(#clip0_onboarding_downloadpage)">
      <path
        d="M14.5644 27.3067L20.761 21.4969C21.0058 21.2773 21.3326 21.1563 21.6714 21.1597C22.0103 21.1632 22.3342 21.2909 22.5738 21.5155C22.8134 21.7401 22.9497 22.0437 22.9535 22.3614C22.9573 22.679 22.8283 22.9854 22.5941 23.215L16.3965 29.0248C16.2551 29.1573 16.075 29.2477 15.879 29.2845L13.8894 29.6576L14.2874 27.7919C14.3266 27.6081 14.423 27.4393 14.5644 27.3067Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.7129 22.7739L21.232 24.1981"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </g>
    <rect
      x="1"
      y="1"
      width="24.9106"
      height="32.1808"
      rx="4"
      stroke="currentColor"
      strokeWidth="2"
    />
    <line
      x1="1.73584"
      y1="7.13818"
      x2="26.9701"
      y2="7.13818"
      stroke="currentColor"
      strokeWidth="2"
    />
    <line
      x1="1.76587"
      y1="16.0903"
      x2="27.0001"
      y2="16.0903"
      stroke="currentColor"
      strokeWidth="2"
    />
    <defs>
      <clipPath id="clip0_onboarding_downloadpage">
        <rect width="26.9106" height="34.1808" rx="5" fill="white" />
      </clipPath>
    </defs>
  </Icon>
);

export default CustomRealtimeUpdateIcon;
